import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var Skeleton = function (_a) {
    var _b = _a.width, width = _b === void 0 ? "w-full" : _b, _c = _a.color, color = _c === void 0 ? "bg-gray-200" : _c, _d = _a.opacity, opacity = _d === void 0 ? 100 : _d, _e = _a.display, display = _e === void 0 ? true : _e;
    return (_jsx("div", { className: "".concat(width, " ").concat(color, " opacity-").concat(opacity, " animate-pulse px-4 py-3 sm:px-6 rounded-md transition:shadow ease-in-out duration-300") }, void 0));
};
export default Skeleton;
